import { TextField } from "@/app/fields";
import { ROLE_LABEL } from "@/app/auth";
import { toOptions } from "@/app/master";
import type { Errors } from "@/app/useDraft";
import { Field, Form, RadioGroup, Switch } from "@/ui";
import { OPERATOR_PASSWORD_RULE } from "@/app/password";
import type { AdminUserDraft } from "./adminUserDraft";

interface Props { draft: AdminUserDraft; errors: Errors<AdminUserDraft>; set: <K extends keyof AdminUserDraft>(k: K, v: AdminUserDraft[K]) => void; isNew: boolean }

/** 后台账号表单的字段（docs/04 第 9 节）。改密码或停用会撤销该账号的全部会话。 */
export function AdminUserForm({ draft, errors, set, isNew }: Props) {
  return (
    <Form>
      <TextField id="u-name" label="用户名" required mono value={draft.username} error={errors.username} onChange={(v) => set("username", v)} />
      <TextField id="u-password" label="密码" required={isNew} type="password" value={draft.password} error={errors.password}
        hint={isNew ? OPERATOR_PASSWORD_RULE : `留空表示不改；改了需满足：${OPERATOR_PASSWORD_RULE}；会踢出该账号的全部会话`} onChange={(v) => set("password", v)} />
      <Field label="角色" required>
        <RadioGroup name="role" inline value={draft.role} onChange={(v) => set("role", v)} options={toOptions(ROLE_LABEL)} />
      </Field>
      {!isNew && <Switch label="启用" checked={draft.status === "active"} onChange={(on) => set("status", on ? "active" : "disabled")} />}
    </Form>
  );
}
